import { Flex } from "@/base/components/index";
import { HeaderProps } from "../types/index";
import { HeaderBreadcrumb } from "./header-breadcrumb";
import { HeaderTitle } from "./header-title";
import { useHeaderStyles } from "./header.styles";

export const Header = ({
  title,
  subtitle,
  description,
  icon,
  breadcrumbItems,
  breadcrumbClassName,
}: HeaderProps) => {
  const { styles } = useHeaderStyles();

  return (
    <Flex gap={32} vertical className={styles.root}>
      {breadcrumbItems?.length && (
        <HeaderBreadcrumb
          items={breadcrumbItems}
          className={breadcrumbClassName}
        />
      )}
      <HeaderTitle
        title={title}
        subtitle={subtitle}
        description={description}
        icon={icon}
      />
    </Flex>
  );
};
